import React, { useState, useEffect, useMemo, memo } from "react";
import {
  FaGithub,
  FaFacebookF,
  FaWhatsapp,
  FaLocationArrow,
  FaLinkedin,
} from "react-icons/fa";

import { HiArrowNarrowRight } from "react-icons/hi";
import { motion } from "framer-motion";
import "../styles/Footer.css";

const GRID_SQUARE_COUNT = 400;

const SOCIAL_LINKS = [
  { href: "https://github.com/RehamRaed", Icon: FaGithub, label: "GitHub" },
  { href: "https://www.linkedin.com/in/reham-raed-magharee", Icon: FaLinkedin, label: "LinkedIn" },
  { href: "https://www.facebook.com/profile.php?id=100012351940033", Icon: FaFacebookF, label: "Facebook" },
  { href: "https://wa.me/972593230201", Icon: FaWhatsapp, label: "WhatsApp" },
];

const SocialIcon = memo(function SocialIcon({ href, Icon, label }) {
  return (
    <div className="icon-circle">
      <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
        <Icon />
      </a>
    </div>
  );
});

const Footer = memo(function Footer() {
  const [initialY, setInitialY] = useState("-3rem");

  useEffect(() => {
    let timeoutId = null;

    const updateInitialY = () => {
      const width = window.innerWidth;
      if (width <= 480) {
        setInitialY("-1.5rem");
      } else if (width <= 650) {
        setInitialY("-2rem");
      } else {
        setInitialY("-3rem");
      }
    };

    const debouncedUpdate = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(updateInitialY, 150);
    };

    updateInitialY();
    window.addEventListener("resize", debouncedUpdate, { passive: true });

    return () => {
      window.removeEventListener("resize", debouncedUpdate);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  return (
    <section className="footer-section">
      <div className="footer-text">
        <motion.h2
          initial={{ y: initialY, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{
            type: "spring",
            stiffness: 80,
            damping: 5,
          }}
        >
          Ready to take <span>your</span> digital presence to the next level?
        </motion.h2>

        <p className="footer_p">
          Reach out today, and together we’ll craft a strategy to turn your goals into reality
        </p>
        <a
          href="https://wa.me/972593230201"
          target="_blank"
          rel="noopener noreferrer"
          className="border-gradient-btn"
          style={{ marginTop: "8px" }}
        >
          Let’s get in touch{" "}
          <span>
            <FaLocationArrow size={14} />
          </span>
        </a>
      </div>

      <div className="social-media">
        <p className="follow-text">
          Follow Me On Social Media{" "}
          <span className="arrow-icon">
            <HiArrowNarrowRight size={20} color="#fff" />
          </span>
        </p>
        <div className="icon-circles">
          {SOCIAL_LINKS.map(({ href, Icon, label }) => (
            <SocialIcon key={href} href={href} Icon={Icon} label={label} />
          ))}
        </div>
      </div>

      <div className="grid-overlay2">
        {useMemo(
          () =>
            Array.from({ length: GRID_SQUARE_COUNT }, (_, index) => (
              <div key={index} className="grid-square2" />
            )),
          []
        )}
      </div>
    </section>
  );
});

export default Footer;
